module.exports = __webpack_public_path__ + "img/2020_HH_2019_Kismarosi_előadás2.f44f9ccd.jpg";